module.exports = __webpack_public_path__ + "img/tips3.370d6469.png";